import React, { useState } from "react";
import circleImage from "../assets/images/circleIcon.png";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import ApiLoader from "../components/ApiLoader";
import API_BASE_URL from "../utilities/ApiConfig";

const DummyModal = ({
  isOpen,
  onclose,
  modifyData,
  propertyEvalMod,
  partyDetailMod,
  updatePartyInState,
}) => {
  const [activeTab, setActiveTab] = useState("tab-1");
  const [selectedRate, setSelectedRate] = useState("from");
  const [open, setOpen] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formattedDate, setFormattedDate] = useState("");
  const [relations, setRelations] = useState([]);
  const [occupations, setOccupations] = useState([]);
  const [idTypes, setIdTypes] = useState([]);
  const [states, setStates] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggleAccordion = (index) => {
    setOpen(open === index ? null : index);
  };

  const handleRateChange = (event) => {
    setSelectedRate(event.target.value);
  };
  const [editingRowData, setEditingRowData] = useState(null);
  const [selectedSectionTitle, setSelectedSectionTitle] = useState("");

  const [partyData, setPartyData] = useState({
    idType: "",
    idNo: "",
    name: "",
    nameHindi: "",
    relation: "",
    relativeName: "",
    relativeNameHindi: "",
    gender: "",
    occupation: "",
    mobile: "",
    selectedOption: "",
    dob: "",
    panNumber: "",
    form60: "",
    email: "",
    houseNo: "",
    locality: "",
    area: "",
    selectedState: "",
    selectedDistrict: "",
    pincode: "",
    country: "India",
  });

  console.log("selected option:", partyData.selectedOption);

  const [localPartyDetails, setLocalPartyDetails] = useState(partyDetailMod);

  useEffect(() => {
    // Sync local state with parent prop when `partyDetailMod` updates
    setLocalPartyDetails(partyDetailMod);
  }, [partyDetailMod]);

  // Handle ID Type select change
  const handleIDTypeChange = (e) => {
    setPartyData({
      ...partyData,
      idType: e.target.value,
    });
  };

  // Handle ID Number input change
  const handleIDNoChange = (e) => {
    setPartyData({
      ...partyData,
      idNo: e.target.value,
    });
  };

  // Handle Name input change
  const handleNameChange = (e) => {
    setPartyData({
      ...partyData,
      name: e.target.value,
    });
  };

  // Handle Name in Hindi input change
  const handleNameHindiChange = (e) => {
    setPartyData({
      ...partyData,
      nameHindi: e.target.value,
    });
  };

  // Handle Relation select change
  const handleRelationChange = (e) => {
    setPartyData({
      ...partyData,
      relation: e.target.value,
    });
  };

  // Handle Relative Name input change
  const handleRelativeNameChange = (e) => {
    setPartyData({
      ...partyData,
      relativeName: e.target.value,
    });
  };
  const handleRelativeNameHindiChange = (e) => {
    setPartyData({
      ...partyData,
      relativeNameHindi: e.target.value,
    });
  };

  // Handle Gender input change
  const handleGenderChange = (e) => {
    setPartyData({
      ...partyData,
      gender: e.target.value,
    });
  };

  // Handle Occupation select change
  const handleOccupationChange = (e) => {
    setPartyData({
      ...partyData,
      occupation: e.target.value,
    });
  };

  // Handle Mobile No. input change
  const handleMobileChange = (e) => {
    setPartyData({
      ...partyData,
      mobile: e.target.value,
    });
  };

  // Handle Email input change
  const handleEmailChange = (e) => {
    setPartyData({
      ...partyData,
      email: e.target.value,
    });
  };

  // Handle House No. input change
  const handleHouseNoChange = (e) => {
    setPartyData({
      ...partyData,
      houseNo: e.target.value,
    });
  };

  // Handle Locality input change
  const handleLocalityChange = (e) => {
    setPartyData({
      ...partyData,
      locality: e.target.value,
    });
  };

  // Handle Area input change
  const handleAreaChange = (e) => {
    setPartyData({
      ...partyData,
      area: e.target.value,
    });
  };

  // Handle State select change
  const handleStateChange = (e) => {
    debugger;
    const selectedStateValue = e.target.value;
    setPartyData({ ...partyData, selectedState: selectedStateValue });

    // Optionally reset selected district when state changes
  };

  // State change handler for selecting district
  const handleDistrictChange = (e) => {
    setPartyData({ ...partyData, selectedDistrict: e.target.value });
  };

  // Handle Pincode input change
  const handlePincodeChange = (e) => {
    setPartyData({
      ...partyData,
      pincode: e.target.value,
    });
  };

  // Form state for all tabs
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
  });

  const [propertyData, setPropertyData] = useState({
    khewat: "",
    khatoni: "",
    khasra: "",
    houseNo: "",
    east: "",
    west: "",
    north: "",
    south: "",
  });
  useEffect(() => {
    if (modifyData) {
      setPropertyData({
        khewat: modifyData?.khewat || "",
        khatoni: modifyData?.khatoni || "",
        khasra: modifyData?.khasra || "",
        houseNo: modifyData?.must || "",
        east: modifyData?.east || "",
        west: modifyData?.west || "",
        north: modifyData?.north || "",
        south: modifyData?.south || "",
      });
    }
  }, [modifyData]);

  const handlePropertyInputChange = (e) => {
    const { name, value } = e.target;
    setPropertyData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (propertyEvalMod.exeDate) {
      const dateObject = new Date(propertyEvalMod.exeDate);
      const day = String(dateObject.getDate()).padStart(2, "0");
      const month = String(dateObject.getMonth() + 1).padStart(2, "0");
      const year = dateObject.getFullYear();
      setFormattedDate(`${day}/${month}/${year}`);
    }
  }, [propertyEvalMod?.exeDate]);

  useEffect(() => {
    debugger;
    const fetchData = async () => {
      try {
        // Fetch all data concurrently
        const [relationRes, occupationRes, idTypeRes, stateRes, genderRes] =
          await Promise.all([
            axios.get(`${API_BASE_URL}/ModifyPDE/Get_Relation`),
            axios.get(`${API_BASE_URL}/ModifyPDE/Get_Occupation`),
            axios.get(`${API_BASE_URL}/ModifyPDE/Get_IDType`),
            axios.get(`${API_BASE_URL}/ModifyPDE/getStateMaster`),
            axios.get(`${API_BASE_URL}/ModifyPDE/Get_GENDER`),
          ]);

        // Store data in state
        setRelations(relationRes.data);
        setOccupations(occupationRes.data);
        setIdTypes(idTypeRes.data);
        setStates(stateRes.data);
        setGenderData(genderRes.data);
        debugger;
      } catch (err) {
        toast.error("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchDistricts = async () => {
      if (!partyData.selectedState) return; // Don't fetch if no state is selected

      try {
        const response = await axios.get(
          `${API_BASE_URL}/ModifyPDE/getDistrictMaster?StateID=${partyData.selectedState}`
        );

        // Log the response for debugging
        console.log("Districts fetched:", response.data);

        setDistricts(response.data); // Set the fetched districts
      } catch (err) {
        console.error("Error fetching districts:", err);
        setDistricts([]); // Reset districts on error
      }
    };

    fetchDistricts();
  }, [partyData.selectedState]);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const allPartyDetails = [
    ...partyDetailMod.savefirstparty,
    ...partyDetailMod.savesecondparty,
    ...partyDetailMod.savewitness,
  ];

  const firstPartyDetails = allPartyDetails.filter((party) =>
    party.pcode?.startsWith("01")
  );
  const secondPartyDetails = allPartyDetails.filter((party) =>
    party.pcode?.startsWith("02")
  );
  const witnessDetails = allPartyDetails.filter((party) =>
    party.pcode?.startsWith("03")
  );
  debugger;
  console.log("firstParty:", firstPartyDetails);
  console.log("secondParty:", secondPartyDetails);
  console.log("witness:", witnessDetails);
  console.log("partymod:", partyDetailMod);
  console.log("Aadhaar:", partyData?.aadhaarEkyc);
  debugger;
  // const aadhaarEkyc = firstPartyDetails[0]?.aadhaarEkyc;
  const tabs = [
    { id: "tab-1", label: "1. Property Details" },
    { id: "tab-2", label: "2. Property Evaluation" },
    { id: "tab-3", label: "3. Party Details" },
  ];

  const sections = [
    {
      title: "First Party Details",
      key: "firstParty",
      data: firstPartyDetails,
    },
    {
      title: "Second Party Details",
      key: "secondParty",
      data: secondPartyDetails,
    },
    { title: "Witness Details", key: "witness", data: witnessDetails },
  ];
  // const renderSectionData = (key) => {
  //   switch (key) {
  //     case "firstParty":
  //       return firstParty;
  //     case "secondParty":
  //       return secondParty;
  //     case "witness":
  //       return witness;
  //     default:
  //       return [];
  //   }
  // };

  const handleEdit = (e, rowData, sectionTitle) => {
    e.preventDefault();
    setShowForm(true);
    setEditingRowData(rowData);
    debugger;
    // Trim the "Details" from section title
    const trimmedTitle = sectionTitle.replace(" Details", "");
    setSelectedSectionTitle(trimmedTitle);
    debugger;
    // Set form fields with data from rowData
    setPartyData((prevData) => ({
      ...prevData,
      aadhaarEkyc: rowData.aadhaarEkyc ?? "",
      selectedOption: rowData.paN_Form60 || "PAN", // Set radio button based on form60 or PAN
      dob: rowData.dob ? rowData.dob.split("T")[0] : "", // Format the date properly if dob is present
      form60: rowData.form60 ? rowData.form60.split("T")[0] : "", // Format the date properly if dob is present
      panNumber: rowData.paN_no || "", // Set PAN if present
      idType: rowData.id_Type_Code || "", // Set the ID type code (e.g., "04" for ADHAAR)
      idNo: rowData.id_No || "", // Set the ID number
      relation: rowData.relation || "", // Set relation
      relativeName: rowData.father_Name_Eng || "N/A", // Set relation name
      relativeNameHindi: rowData.father_Name_Hin || "N/A", // Set Hindi relation name (if applicable)
      occupation: rowData.occu_Code || "", // Set occupation code
      mobile: rowData.mobile_No || "", // Set mobile number (if present)
      selectedState: rowData.state || "", // Set the selected state
      selectedDistrict: rowData.district || "", // Set the selected district
      pincode: rowData.pincode || "", // Set pincode (if applicable)
      name: rowData.name_Eng || "", // Set name
      nameHindi: rowData.name_Hin || "", // Set Hindi name
      gender: rowData.gendeR_CODE || "", // Set gender
      email: rowData.email || "", // Set email (if applicable)
      houseNo: rowData.house_no || "", // Set house number (if applicable)
      locality: rowData.landmark || "", // Set locality
      area: rowData.street || "", // Set area (if applicable)
    }));
    debugger;
    // Optionally, handle setting other fields as needed (e.g., Address, Gender)
  };

  const handleUpdate = () => {
    switch (activeTab) {
      case "tab-1":
        // Call API for Property Details
        updatePropertyDetails();
        break;

      case "tab-3":
        // Call API for Party Details
        updatePartyDetails();
        break;
      default:
        console.error("Invalid tab selected");
    }
  };

  const updatePropertyDetails = async () => {
    debugger;
    try {
      const propertyUrl = `${API_BASE_URL}/ModifyPDE/UpdatePropertyDetails`;

      // Construct request body
      const requestBody = {
        pdeId: modifyData?.pdE_ID || "", // Ensure it's not undefined
        ...propertyData,
      };

      console.log("Request Payload:", requestBody);

      // API request
      const response = await axios.put(propertyUrl, requestBody, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      });

      console.log("Response:", response.data);
      if (response.data.statusCode === "200") {
        toast.success("Updated Successfully");
        // onclose();
      } else {
        toast.error("Error updating Property Data");
      }
    } catch (error) {
      console.error("Error updating property details:", error);
    }
  };

  // const updatePartyDetails = () => {
  //   console.log("Updating Party Details...");
  //   // API call logic here
  // };
  const updatePartyDetails = async () => {
    if (!editingRowData) {
      console.error("No row selected for editing");
      return;
    }
    debugger;
    try {
      const updateUrl = `${API_BASE_URL}/ModifyPDE/Update_PartyDetails_modify`;

      const updatedRowData = {
        pdE_ID: modifyData?.pdE_ID || "",
        pcode: editingRowData.pcode || "",
        name_Hin: partyData.nameHindi || "",
        name_Eng: partyData.name || "",
        dob: partyData.dob || "",
        gendeR_CODE: partyData.gender || "",
        relation: partyData.relation || "",
        father_Name_Hin: partyData.relativeNameHindi || "",
        father_Name_Eng: partyData.relativeName || "",
        country: partyData.country || "India",
        state: partyData.selectedState || "",
        district: partyData.selectedDistrict || "",
        vtc: partyData.locality || "",
        street: partyData.area || "",
        house_no: partyData.houseNo || "",
        landmark: "", // No landmark provided in form, keeping as empty string
        pincode: partyData.pincode || "",
        occu_Code: partyData.occupation || "",
        paN_Form60:
          partyData.selectedOption === "form60" ? partyData.form60 : "",
        paN_no: partyData.selectedOption === "PAN" ? partyData.panNumber : "",
        form60: partyData.selectedOption === "form60" ? partyData.form60 : "",
        mobile_No: partyData.mobile || "",
        id_Type_Code: partyData.idType || "",
        id_No: partyData.idNo || "",
        email: partyData.email || "",
      };
      console.log("Updating Row Data:", updatedRowData);

      const response = await axios.put(updateUrl, updatedRowData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      });
      debugger;
      if (response.data.statusCode === "200") {
        toast.success(
          `${updatedRowData.name_Eng}'s Details Updated Successfully`
        );

        // ✅ Update local state in DummyModal
        setLocalPartyDetails((prevState) => ({
          ...prevState,
          savefirstparty: prevState.savefirstparty.map((party) =>
            party.pcode === updatedRowData.pcode
              ? { ...party, updated: true }
              : party
          ),
          savesecondparty: prevState.savesecondparty.map((party) =>
            party.pcode === updatedRowData.pcode
              ? { ...party, updated: true }
              : party
          ),
          savewitness: prevState.savewitness.map((party) =>
            party.pcode === updatedRowData.pcode
              ? { ...party, updated: true }
              : party
          ),
        }));

        // ✅ Also update the parent state
        updatePartyInState({ ...updatedRowData, updated: true });

        setShowForm(false); // Close the form after update
      } else {
        toast.error("Failed to update Party Details");
      }
    } catch (error) {
      console.error("Error updating party details:", error);
      toast.error("Error updating Party Details");
    }
  };

  return (
    <>
      {loading && <ApiLoader />}
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary-black bg-opacity-50">
        {/* <div className="bg-white w-full max-w-5xl 3xl:max-w-7xl  min-h-[60vh] md:min-h-[70vh] lg:min-h-[80vh] xl:min-h-[620px]"> */}
        <div className="bg-white w-full max-w-5xl 3xl:max-w-7xl h-[65vh]">
          {/* Custom Header */}
          <div className="relative bg-[#CAE5FF] px-4 py-2 flex items-center justify-between border-b-4 border-[#3A8FF6]">
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-2 shadow-md">
              <img src={circleImage} alt="Circle Icon" className="h-12 w-12" />
            </div>
            <h2 className="text-lg font-semibold ml-4">Modify Details</h2>
            <button
              onClick={() => {
                onclose();
              }}
              className="text-secondary-600 hover:text-secondary-900"
            >
              <CloseOutlinedIcon />
            </button>
          </div>
          <div className="mx-4 my-2 font-['Trebuchet_MS']">
            {/* Tab Headers */}
            <ul className="flex border-b-0">
              {tabs.map((tab) => (
                <li
                  key={tab.id}
                  className={`px-12 py-2 text-black font-bold rounded-t-xl display: inline-block  ${
                    tab.className
                  } ${
                    activeTab === tab.id
                      ? " border border-b-0 border-primary-50 bg-secondary-50"
                      : "opacity-70"
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.label}
                </li>
              ))}
            </ul>

            {/* Tab Content */}

            <div className="p-5 border border-t-0 border-primary-50 bg-secondary-50  rounded-b-lg">
              {activeTab === "tab-1" && (
                <div>
                  <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="1"
                          type="text"
                          value={modifyData?.district || ""}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="1"
                          className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                        >
                          District
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="2"
                          type="text"
                          value={modifyData?.sroname || ""}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="2"
                          className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                        >
                          SRO
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="3"
                          type="text"
                          value={modifyData?.deedname || ""}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="3"
                          className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                        >
                          Article / Deed type
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="4"
                          type="text"
                          value={modifyData?.subdeedname || ""}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="4"
                          className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                        >
                          Sub-Deed Type
                        </label>
                      </div>
                    </div>
                  </div>
                  {modifyData?.deedname !== "Will" && (
                    <>
                      <div className="flex items-center space-x-4 mt-4">
                        <label className="text-sm font-medium">
                          Select Rate List
                        </label>
                        <div className="flex items-center space-x-2">
                          <label className="flex items-center space-x-1">
                            <input
                              type="radio"
                              name="rateList"
                              value="from"
                              checked={selectedRate === "from"}
                              onChange={handleRateChange}
                              className="w-4 h-4 accent-blue-600 "
                            />
                            <span>From 16 Feb 2023</span>
                          </label>
                          <label className="flex items-center space-x-1">
                            <input
                              type="radio"
                              name="rateList"
                              value="before"
                              checked={selectedRate === "before"}
                              onChange={handleRateChange}
                              className="w-4 h-4 accent-blue-600"
                            />
                            <span>Before 16 Feb 2023</span>
                          </label>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mt-4">
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="LandRateCalculation"
                              type="text"
                              value={modifyData?.location || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="LandRateCalculation"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Land Rate Calculation
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="Circlerate "
                              type="text"
                              value={modifyData?.location_Circle_Rate || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="Circle rate "
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              Circle rate
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="VillageMauzaIndex"
                              type="text"
                              value={modifyData?.mauzaIndex || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="VillageMauzaIndex"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Village / Mauza for Index
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="Mutation"
                              type="text"
                              value={modifyData?.mutationDepartment || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="Mutation"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              Select Mutation Details
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="OfficeDetails"
                              type="text"
                              value={modifyData?.mutationOffice || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="OfficeDetails"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Select Office Details
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="Rebate"
                              type="text"
                              //   value={modifyData?.location_Circle_Rate || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="Rebate"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              Select Rebate
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="Khewat"
                              type="text"
                              name="khewat"
                              value={propertyData?.khewat || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="Khewat"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Khewat No.
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="Khatoni"
                              type="text"
                              name="khatoni"
                              value={propertyData?.khatoni || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="Khatoni"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              Khatoni No.
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="Khasra"
                              type="text"
                              name="khasra"
                              value={propertyData?.khasra || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="Khasra"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Khasra No.
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="HouseNo"
                              type="text"
                              name="houseNo"
                              value={propertyData?.houseNo || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="HouseNo"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              House / Flat No.
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="floorno"
                              type="text"
                              value={modifyData?.floorNo || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="floorno"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Select Floor
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="AreaUnit"
                              type="text"
                              value={`${modifyData?.area ?? ""} ${
                                modifyData?.unit ?? ""
                              }`}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="AreaUnit"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              Area/Unit
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="latitude"
                              type="text"
                              value={modifyData?.latitude || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="latitude"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Property Latitude
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="longitude"
                              type="text"
                              value={modifyData?.longitude || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="longitude"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              Property Longitude
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="rider"
                              type="text"
                              value={modifyData?.rider || ""}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                              disabled
                            />
                            <label
                              htmlFor="rider"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              Rider
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="mt-4">
                        <span>Property Boundries</span>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="east"
                              type="text"
                              name="east"
                              value={propertyData?.east || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="east"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              East
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="west"
                              type="text"
                              name="west"
                              value={propertyData?.west || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="west"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              West
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="north"
                              type="text"
                              name="north"
                              value={propertyData?.north || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="north"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              North
                            </label>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className="relative">
                            <input
                              id="south"
                              type="text"
                              name="south"
                              value={propertyData?.south || ""}
                              onChange={handlePropertyInputChange}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="south"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                            >
                              South
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}

              {activeTab === "tab-2" && (
                <div>
                  <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="Advance"
                          type="text"
                          value={propertyEvalMod.advance}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="Advance"
                          className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                        >
                          Advance/Security
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="transactionValue"
                          type="text"
                          value={propertyEvalMod.transValue}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="transactionValue"
                          className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                        >
                          Transaction Value
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="executiondate"
                          type="text"
                          value={formattedDate}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="executiondate"
                          className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                        >
                          Execution Date
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="premiumPagdi"
                          type="text"
                          value={""}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="premiumPagdi"
                          className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                        >
                          Premium / Pagdi
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="modeofpayment"
                          type="text"
                          value={propertyEvalMod.modePayment}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="modeofpayment"
                          className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                        >
                          Mode of Payment
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="deedwriter"
                          type="text"
                          value={propertyEvalMod.dwrName}
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="deedwriter"
                          className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                        >
                          Deed Writer
                        </label>
                      </div>
                    </div>

                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="electricitynamechange"
                          type="text"
                          value=""
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="electricitynamechange"
                          className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                        >
                          Electricity coonection Name Change
                        </label>
                      </div>
                    </div>
                    <div className="col-1">
                      <div className="relative">
                        <input
                          id="waternamechange"
                          type="text"
                          value=""
                          className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          placeholder=""
                          disabled
                        />
                        <label
                          htmlFor="waternamechange"
                          className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                        >
                          Water connection name Change
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4">
                    <span>
                      <b>Fees and Stamp duty details :</b>
                    </span>
                  </div>
                  <div className="p-3">
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4 ">
                      <div className="col-1 flex justify-between">
                        <span>Circle rate :</span>
                        <span className="text-primary-500">
                          {propertyEvalMod.locationCircleRate || 0}{" "}
                        </span>
                      </div>
                      <div className="col-1 flex justify-between">
                        <span>Govt Value :</span>
                        <span className="text-primary-500">
                          {propertyEvalMod.mValue || 0}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                      <div className="col-1 flex justify-between">
                        <span>Land/Floor Value :</span>
                        <span className="text-primary-500">
                          {propertyEvalMod.landCost || 0}{" "}
                        </span>
                      </div>
                      <div className="col-1 flex justify-between">
                        <span>Structure Value :</span>
                        <span className="text-primary-500">
                          {propertyEvalMod.structCost || 0}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                      <div className="col-1 flex justify-between">
                        <span>Total Stamp Duty :</span>
                        <span className="text-primary-500">
                          {propertyEvalMod.stampDuty || 0}{" "}
                        </span>
                      </div>
                      <div className="col-1 flex justify-between">
                        <span>Registration Fees :</span>
                        <span className="text-primary-500">
                          {propertyEvalMod.rFee || 0}{" "}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="totalpages"
                            type="text"
                            value={propertyEvalMod.page || ""}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                            disabled
                          />
                          <label
                            htmlFor="totalpages"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            Total Pages
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="totalwords"
                            type="text"
                            value={propertyEvalMod.word || ""}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                            disabled
                          />
                          <label
                            htmlFor="totalwords"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            Total Words in deed
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "tab-3" &&
                (editingRowData && showForm ? (
                  <div className="p-5 border border-t-0 border-primary-50 bg-secondary-50  rounded-b-lg">
                    <div className="p-2 border border-t-0 border-primary-50 border-b-2 border-b-secondary-300 rounded-lg flex items-center justify-between  bg-white">
                      <div className="flex items-center space-x-2">
                        <PeopleAltOutlinedIcon className="text-primary mr-2" />

                        <h2 className="text-lg font-bold">
                          {partyData?.name || "No Name"} -{" "}
                          {selectedSectionTitle || "No Section"}
                        </h2>
                      </div>
                      <button
                        onClick={() => setShowForm(false)}
                        className="text-[#DA0000]"
                      >
                        <CloseOutlinedIcon />
                      </button>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                      <div className="col-1">
                        <div className="relative">
                          <select
                            id="IDType"
                            value={partyData.idType} // Bind the selected value to the state
                            onChange={handleIDTypeChange} // Set the ID type when changed
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                          >
                            {idTypes.map((id) => (
                              <option key={id.iD_CODE} value={id.iD_CODE}>
                                {id.id}
                              </option>
                            ))}
                          </select>
                          <label
                            htmlFor="IDType"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            ID Type
                          </label>
                        </div>
                      </div>

                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="IDNo"
                            type="text"
                            value={partyData.idNo} // Bind the value of the input to the state
                            onChange={handleIDNoChange} // Update the state on change
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="IDNo"
                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                          >
                            ID No.
                          </label>
                        </div>
                      </div>

                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="Name"
                            type="text"
                            value={partyData.name}
                            onChange={handleNameChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="Name"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            Name
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="NameHindi"
                            type="text"
                            value={partyData.nameHindi}
                            onChange={handleNameHindiChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="NameHindi"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            नाम
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                      <div className="col-1">
                        <div className="relative flex items-center">
                          {/* Select Dropdown */}
                          <div className="relative w-1/4">
                            <select
                              id="relation"
                              value={partyData.relation}
                              onChange={handleRelationChange}
                              disabled={partyData?.aadhaarEkyc === "Y"}
                              className="w-full h-8 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            >
                              {relations.map((rel) => (
                                <option
                                  key={rel.relatioN_CODE}
                                  value={rel.relatioN_CODE}
                                >
                                  {rel.relation}
                                </option>
                              ))}
                            </select>

                            {/* Floating Label for Select */}
                            <label
                              htmlFor="relation"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 left-2 z-10 bg-white dark:bg-gray-900 px-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4"
                            >
                              Relation
                            </label>
                          </div>

                          {/* Input Field */}
                          <div className="relative w-3/4">
                            <input
                              id="relativeName"
                              type="text"
                              value={partyData.relativeName}
                              onChange={handleRelativeNameChange}
                              disabled={partyData?.aadhaarEkyc === "Y"}
                              className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />

                            {/* Floating Label for Input */}
                            <label
                              htmlFor="relativeName"
                              className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 left-2 z-10 bg-white dark:bg-gray-900 px-1 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4"
                            >
                              Relative Name
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="relativeNamehindi"
                            value={partyData.relativeNameHindi}
                            onChange={handleRelativeNameHindiChange}
                            type="text"
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="2"
                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                          >
                            रिश्तेदार
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <select
                            id="gender"
                            value={partyData.gender}
                            onChange={handleGenderChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          >
                            {genderData.map((gen) => (
                              <option
                                key={gen.gendeR_CODE}
                                value={gen.gendeR_CODE}
                              >
                                {gen.gender}
                              </option>
                            ))}
                          </select>
                          <label
                            htmlFor="gender"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            Gender
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <select
                            id="Occupation"
                            value={partyData.occupation}
                            onChange={handleOccupationChange}
                            className="w-full h-8 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                          >
                            {occupations?.map((occ) => (
                              <option
                                key={occ.occupatioN_CODE}
                                value={occ.occupatioN_CODE}
                              >
                                {occ.occupation}
                              </option>
                            ))}
                          </select>
                          <label
                            htmlFor="4"
                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                          >
                            Occupation
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-4 mt-4">
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="Mobile"
                            type="text"
                            value={partyData.mobile}
                            onChange={handleMobileChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="Mobile"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            Mobile No.
                          </label>
                        </div>
                      </div>
                      <div className="col-1 grid grid-cols-4 gap-0 items-center">
                        {selectedSectionTitle === "witness" ? (
                          // D.O.B. input field for Witness
                          <div className="col-span-4">
                            <input
                              type="date"
                              id="dob"
                              value={partyData?.dob}
                              disabled={partyData?.aadhaarEkyc === "Y"}
                              onChange={(e) =>
                                setPartyData({
                                  ...partyData,
                                  dob: e.target.value,
                                })
                              }
                              className="w-full h-8 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                              placeholder=""
                            />
                            <label
                              htmlFor="dob"
                              className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                            >
                              D.O.B
                            </label>
                          </div>
                        ) : (
                          <>
                            {/* Form 60 Radio Button */}
                            <div className="flex items-center space-x-1">
                              <input
                                type="radio"
                                id="form60"
                                name="option"
                                value="form60"
                                checked={partyData?.selectedOption === "form60"}
                                onChange={() =>
                                  setPartyData({
                                    ...partyData,
                                    selectedOption: "form60",
                                  })
                                }
                              />
                              <label
                                htmlFor="form60"
                                className="text-sm font-medium"
                              >
                                Form 60
                              </label>
                            </div>

                            {/* PAN Radio Button */}
                            <div className="flex items-center space-x-1">
                              <input
                                type="radio"
                                id="PAN"
                                name="option"
                                value="PAN"
                                checked={partyData.selectedOption === "PAN"}
                                onChange={() =>
                                  setPartyData({
                                    ...partyData,
                                    selectedOption: "PAN",
                                  })
                                }
                              />
                              <label
                                htmlFor="PAN"
                                className="text-sm font-medium"
                              >
                                PAN no.
                              </label>
                            </div>

                            {/* Conditional Input Field (Spans 2 Columns) */}
                            <div className="relative col-span-2">
                              {partyData.selectedOption === "form60" ? (
                                <input
                                  type="date"
                                  value={partyData.form60}
                                  onChange={(e) =>
                                    setPartyData({
                                      ...partyData,
                                      form60: e.target.value,
                                    })
                                  }
                                  className="w-full h-8 border border-gray-300 p-2 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                              ) : (
                                <div className="relative">
                                  <input
                                    type="text"
                                    id="panNumber"
                                    value={partyData.panNumber}
                                    onChange={(e) =>
                                      setPartyData({
                                        ...partyData,
                                        panNumber: e.target.value,
                                      })
                                    }
                                    className="peer w-full h-8 border border-gray-300 p-2 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  />
                                  <label
                                    htmlFor="panNumber"
                                    className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                                  >
                                    Enter PAN
                                  </label>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>

                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="Email"
                            type="text"
                            value={partyData.email}
                            onChange={handleEmailChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="Email"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            Email ID
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative"></div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <span>Address Details:</span>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-4">
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="houseNo"
                            type="text"
                            value={partyData.houseNo}
                            onChange={handleHouseNoChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="houseNo"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            House No
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="Locality"
                            type="text"
                            value={partyData.locality}
                            onChange={handleLocalityChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="Locality"
                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                          >
                            Locality
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="Area"
                            type="text"
                            value={partyData.area}
                            onChange={handleAreaChange}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            placeholder=""
                          />
                          <label
                            htmlFor="Area"
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            Area
                          </label>
                        </div>
                      </div>

                      <div className="col-1">
                        <div className="relative">
                          <select
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            value={partyData.selectedState}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            onChange={handleStateChange}
                          >
                            <option value="">--Select State--</option>
                            {states.map((state) => (
                              <option key={state.stateID} value={state.stateID}>
                                {state.stateName}
                              </option>
                            ))}
                          </select>
                          <label
                            htmlFor="State"
                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                          >
                            State
                          </label>
                        </div>
                      </div>

                      <div className="col-1">
                        <div className="relative">
                          <select
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer text-sm"
                            value={partyData.selectedDistrict}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            onChange={handleDistrictChange}
                          >
                            <option value="">--Select District--</option>
                            {districts.map((district) => (
                              <option
                                key={district.districtID}
                                value={district.districtID}
                              >
                                {district.districtName}
                              </option>
                            ))}
                          </select>
                          <label
                            htmlFor="District"
                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                          >
                            District
                          </label>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className="relative">
                          <input
                            id="Pincode"
                            type="text"
                            value={partyData.pincode}
                            disabled={partyData?.aadhaarEkyc === "Y"}
                            onChange={handlePincodeChange}
                            className="w-full h-8 border border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer"
                            placeholder=""
                          />
                          <label
                            htmlFor="Pincode"
                            className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                          >
                            Pincode
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="">
                    {sections.map((section, index) => (
                      <div
                        key={index}
                        className="shadow-md rounded-lg  m-1 border-b border-secondary-500"
                        //   className="p-2 border border-t-0 border-primary-50 border-b-2 border-b-secondary-300 rounded-lg"
                      >
                        {/* Accordion Header */}
                        <button
                          className="flex items-center justify-between rounded-lg w-full p-3 bg-white"
                          onClick={() => toggleAccordion(index)}
                        >
                          <div className="flex items-center">
                            <PeopleAltOutlinedIcon className="text-primary mr-2" />
                            {section.title}
                          </div>
                          <span
                            className={`transform transition-transform ${
                              open === index ? "rotate-180" : ""
                            }`}
                          >
                            ▼
                          </span>
                        </button>

                        {open === index && (
                          <div className="p-1 border-t border-secondary-700">
                            <div className="h-[24vh] overflow-y-auto">
                              <div className="grid grid-cols-12 gap-2 text-center">
                                <div className="p-0 font-semibold col-span-1">
                                  Sr. No.
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  Name
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  Gender
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  Relation
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  Relative Name
                                </div>
                                <div className="p-0 font-semibold col-span-2">
                                  Address
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  Mobile No.
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  ID Type
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  ID No.
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  Edit
                                </div>
                                <div className="p-0 font-semibold col-span-1">
                                  Modification
                                </div>

                                {section.data.length > 0 ? (
                                  section.data.map((row, i) => (
                                    <React.Fragment key={`${section.key}-${i}`}>
                                      <div className="p-0 col-span-1">
                                        {i + 1}
                                      </div>
                                      <div className="p-0 col-span-1">
                                        {row.name_Eng}
                                      </div>
                                      <div className="p-0 col-span-1">
                                        {row.gender}
                                      </div>
                                      <div className="p-0 col-span-1">
                                        {row.relation}
                                      </div>
                                      <div className="p-0 col-span-1">
                                        {row.father_Name_Eng}
                                      </div>
                                      <div className="p-0 col-span-2">{`${row.house_no}, ${row.street}, ${row.districtName}, ${row.stateName}`}</div>
                                      <div className="p-0 col-span-1">
                                        {row.mobile_No}
                                      </div>
                                      <div className="p-0 col-span-1">
                                        {row.idName}
                                      </div>
                                      <div className="p-0 col-span-1">
                                        {row.id_No}
                                      </div>
                                      <div className="p-0 col-span-1">
                                        <button
                                          className="text-primary"
                                          onClick={(e) =>
                                            handleEdit(e, row, section.key)
                                          }
                                        >
                                          <SaveAsOutlinedIcon />
                                        </button>
                                      </div>
                                      <div className="p-0 col-span-1">
                                        {row.updated ? (
                                          <CheckBoxIcon className="text-success" />
                                        ) : (
                                          <CheckBoxOutlineBlankIcon />
                                        )}
                                      </div>
                                    </React.Fragment>
                                  ))
                                ) : (
                                  <div
                                    colSpan="11"
                                    className="col-span-11 p-3 text-center text-gray-500"
                                  >
                                    No data available for {section.title}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
            </div>

            {activeTab !== "tab-2" && (
              <div className="flex justify-center mt-4 gap-4">
                <button
                  onClick={handleUpdate}
                  className="w-1/6 h-8 bg-blue-400 text-white px-4 rounded hover:bg-blue-700 focus:outline-none"
                >
                  Update
                </button>
                <button className="w-1/6 h-8 text-[#DA0000] px-4 border border-[#DA0000] rounded hover:bg-red-100 focus:outline-none">
                  CANCEL
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DummyModal;
